<template>
  <div class="main-wrapper">
    <!-- <layout-header3></layout-header3> -->
    <layout-header></layout-header>
    <breadcrumb8></breadcrumb8>
    <!-- Page Content -->
    <div class="content">
      <div class="container">
        <div class="row">
          <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
            <sidebar v-if="currentPath == 'change-password'"></sidebar>
            <sidebar1
              v-else-if="currentPath == 'patient-change-password'"
            ></sidebar1>
          </div>

          <div class="col-md-7 col-lg-8 col-xl-9">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12 col-lg-6">
                    <!-- Change Password Form -->
                    <form @submit.prevent="updatePassword()">
                      <div class="form-group">
                        <label>New Password</label>
                        <input
                          type="password"
                          v-model="user.password"
                          required
                          class="form-control"
                        />
                      </div>
                      <div class="form-group">
                        <label>Confirm Password</label>
                        <input
                          type="password"
                          v-model="user.confirm_password"
                          required
                          class="form-control"
                        />
                        <p class="No_data text-left" v-if="this.validatePass()">
                          Password and confirm password does not match
                        </p>
                      </div>
                      <div class="submit-section">
                        <button
                          :disabled="disabled"
                          type="submit"
                          class="btn btn-primary submit-btn"
                        >
                          Save Changes
                        </button>
                      </div>
                    </form>
                    <!-- /Change Password Form -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->
    <layout-footer></layout-footer>
  </div>
</template>

<script>
import CommonApi from "../services/CommonApi";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      user: {
        password: "",
        confirm_password: "",
      },
      disabled: true,
      username: localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo")).user
        : null,
    };
  },
  computed: {
    currentPath() {
      return this.$route.name;
    },
  },
  watch: {
    user: {
      handler() {
        this.validateForm();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["signOut"]),
    /* Form Validation */
    validateForm() {
      if (
        this.user.password === "" ||
        this.user.confirm_password === "" ||
        this.validatePass()
      ) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },

    /* Check if both password are same */
    validatePass() {
      if (this.user.password !== this.user.confirm_password) {
        return true;
      } else {
        return false;
      }
    },

    /* Update Password */
    async updatePassword() {
      let data = {
        user: this.username,
        password: this.user.confirm_password,
      };
      await CommonApi.post_data(
        "sahaj.bklogin.reset_password",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code === 200) {
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            footer: '<a href="" style="color: red;">Login Again....</a>',
            showConfirmButton: true,
          });
        }
        this.user.password = "";
        this.user.confirm_password = "";
        this.signOut();
        this.$store.dispatch("user/setUserType");
        this.$store.dispatch("user/setUserID");
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ChangePassword.vue